import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { SideBar } from "../../components/SideBar";
import { useSelector } from "react-redux";

import { ReactLoaderSpinner } from "../../components/ReactLoaderSpinner/index.js";
import ModuleQuestion from "../../components/ModuleQuestion";

// services
import { useBookmarkModuleMutation } from "../../store/services/moduleServerApi";

const Module_2_1_1 = () => {
  const { pathname: pathName } = useLocation();
  const { menuItems } = useSelector((state) => state?.moduleSlice);

  const [bookmarkModule, { isLoading: isMenuLoading }] =
    useBookmarkModuleMutation();

  /* Start useEffect */
  useEffect(() => {
    bookmarkModule({ pathName });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // * onPageLoad
  /* End useEffect */

  return (
    <div className="row">
      {isMenuLoading && <ReactLoaderSpinner />}
      {menuItems?.id && <SideBar menuItems={[menuItems]} />}
      <div className="col-sm-8">
        <main className="module-content">
          <section>
            <h1 className="blue text-uppercase b mt-5 mb-4">
              2.4.4 Practice Case 2
            </h1>
            <p className="me-4">Estimated time to complete: 5 minutes</p>
          </section>
          <ModuleQuestion
            correctAnswer="A"
            assessmentName="practice_case_2"
            videoTranscript={
              <>
                <p>
                  <strong>AUDIO</strong>
                  <br />
                  VO: (FEMALE)
                  <br />
                </p>
                <p>This is Practice Case Number 2. This is a positive case. The size and contrast have already been adjusted. Starting at the bottom of the brain and moving superiorly, we enter the cerebellum and notice the normal gray-white contrast for this patient. You may also notice that the patient is tilted to the right, as can be seen on this coronal image. Furthermore, there is increased noise on this case when compared to Practice Case 1. As we enter the temporal lobes, located here and here, you may notice focal uptake anterior to the temporal region. This activity is not in the temporal lobes, but it is important to identify where it is. Utilizing the fused images, you can see that this activity is located within muscle. Returning to the PET images, you may also identify that there is lack of gray-white contrast in the temporal lobe on the left and right. This pattern persists as you move superiorly. When you enter into the occipital regions, you may notice these focal areas of intense uptake. This activity, which is in the gray matter, is more intense than the surrounding white matter, seen here and here. This finding alone would make this scan positive. However, let’s continue to review the remainder of the slices. As we move superiorly, we continue to see lack of gray-white contrast in the occipital and temporal regions. We also find this to be true in the frontal cortices bilaterally. Entering into the parietal lobes, we again do not see clear delineation of the white matter tracts, and, in fact, there is loss of gray-white contrast throughout. As we move superiorly and enter into the medial parietal region, located here, we again see lack of gray-white contrast. The medial parietal region may also be seen on the accompanying sagittal images, as seen here. The review of the remainder of the slices also shows lack of gray-white contrast. Therefore, because there is lack of gray-white contrast in the temporal, occipital, frontal, and parietal regions, this scan is positive. In addition, focal uptake, seen in the occipital lobes, also makes this scan positive.</p>
              </>
            }
            previousLesson="/module-2/module-2-4-3"
            nextLesson="/module-2/module-2-4-5"
            iframeURL="https://cdnapisec.kaltura.com/p/1759891/sp/175989100/embedIframeJs/uiconf_id/24639831/partner_id/1759891?iframeembed=true&playerId=kaltura_player_301873299&entry_id=1_d5917hth&wid=_1759891&flashvars[sideBarContainer.plugin]=true&flashvars[sideBarContainer.position]=left&flashvars[sideBarContainer.clickToClose]=true&flashvars[chapters.plugin]=true&flashvars[chapters.layout]=vertical&flashvars[chapters.thumbnailRotator]=false&flashvars[streamSelector.plugin]=true&flashvars[EmbedPlayer.SpinnerTarget]=videoHolder&flashvars[dualScreen.plugin]=true"
            questionType="practice"
            videoId="1_d5917hth"
          />
        </main>
      </div>
    </div>
  );
};

export default Module_2_1_1;
